import { atom } from "jotai"
import { atomWithStorage, createJSONStorage } from "jotai/utils"

const storage = createJSONStorage<boolean>(() => sessionStorage)
export const bannerIsDisabledAtom = atomWithStorage<boolean>("banner-disabled", false, storage)

export const bannerIsVisible = atom(false)

export const bannerShouldHide = atom(false)
